import { WindowLocation } from "@reach/router";
import { IFilter } from "@src/shared/context/searchfilter/IFilter";
import { stringify } from "query-string";

import { parseTrackingParams } from "../context/searchfilter/generateUrlFromFilter";

export const generateVehicleDetailUrl = (vehicle: { vehicleId: string | null }, filter: IFilter, location: WindowLocation) => {
    return `/detail/${vehicle.vehicleId}?${stringify({ ...filter, ...parseTrackingParams(location.search) })}`;
};
